/**
 * 从 URL query 中提取分享来源参数，过滤掉 undefined 后返回。
 * 用于把桌面 App / 分享接收页传来的 from/source_* 参数透传给 GA4 事件 payload。
 */

export interface ShareSource {
  from?: string;
  source_room_id?: string;
  source_uid?: string;
}

export const getShareSourceFromUrl = (search = window.location.search): ShareSource => {
  const params = new URLSearchParams(search);
  const from = params.get('from') || undefined;
  const source_room_id = params.get('source_room_id') || undefined;
  const source_uid = params.get('source_uid') || undefined;
  return Object.fromEntries(
    Object.entries({ from, source_room_id, source_uid }).filter(([, v]) => v !== undefined),
  ) as ShareSource;
};
